// extracted by css-extract-rspack-plugin
export default {"cls1":"EdgePill-cls1_Ae4","cls2":"EdgePill-cls2_4Lx EdgePill-cls1_Ae4"};